import React from 'react';
import { TravauxSupplementaires } from '../types';

interface TravauxSupplementairesRowProps {
  ts: TravauxSupplementaires;
}

const fmt = (n: number) => n.toLocaleString('fr-FR');

const statutBadge: Record<string, { bg: string; text: string; label: string }> = {
  valide: { bg: 'bg-green-100', text: 'text-green-800', label: 'Validé' },
  en_attente: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'En attente' },
  refuse: { bg: 'bg-red-100', text: 'text-red-800', label: 'Refusé' },
};

const TravauxSupplementairesRow: React.FC<TravauxSupplementairesRowProps> = ({ ts }) => {
  const badge = statutBadge[ts.statut] || statutBadge.en_attente;

  return (
    <tr className="border-b border-gray-100 last:border-b-0">
      <td className="py-2 px-3 text-sm text-gray-900">{ts.intitule}</td>
      <td className="py-2 px-3 text-sm text-right font-semibold text-gray-900">
        {fmt(ts.montant)} €
      </td>
      <td className="py-2 px-3 text-sm text-gray-500">
        {new Date(ts.dateAjout).toLocaleDateString('fr-FR')}
      </td>
      <td className="py-2 px-3">
        <span className={`px-2 py-1 text-xs rounded-full ${badge.bg} ${badge.text}`}>
          {badge.label}
        </span>
      </td>
      <td className="py-2 px-3 text-sm text-gray-500">{ts.commentaire || '—'}</td>
    </tr>
  );
};

export default TravauxSupplementairesRow;
